
namespace TabAurous.Inventory {

    @Serenity.Decorators.registerClass()
    export class MaterialRequestGrid extends Serenity.EntityGrid<MaterialRequestRow, any> {
        protected getColumnsKey() { return 'Inventory.MaterialRequest'; }
        protected getDialogType() { return MaterialRequestDialog; }
        protected getIdProperty() { return MaterialRequestRow.idProperty; }
        protected getInsertPermission() { return MaterialRequestRow.insertPermission; }
        protected getLocalTextPrefix() { return MaterialRequestRow.localTextPrefix; }
        protected getService() { return MaterialRequestService.baseUrl; }
        private rowSelection: Serenity.GridRowSelectionMixin;
        private autoSize;
        constructor(container: JQuery) {
            super(container);
        }
        protected onClick(e: JQueryEventObject, row: number, cell: number) { 
            super.onClick(e, row, cell);
        }
        protected addButtonClick() {

            let now = new Date();

            var voucherNo = FormatHelper.GetVoucherNo(56);
            this.editItem(<MaterialRequestRow>{
                VoucherNo: voucherNo,
                Line_No: 0,
                VoucherTypeId: 56,
                CompanyId: Q.Authorization.userDefinition.CompanyId,
                FinancialYearId: Q.Authorization.userDefinition.FinancialYearId,
                UserId: Q.Authorization.userDefinition.UserId,
                CurrencyId: Q.Authorization.userDefinition.CurrencyId,
                TransDate: now.toDateString()
            });
        }
        protected createSlickGrid(): Slick.Grid {
            let grid = super.createSlickGrid();
            this.autoSize = new Slick.AutoColumnSize();
            grid.registerPlugin(this.autoSize);


            return grid;
        }
        protected createToolbarExtensions() {
            super.createToolbarExtensions();
            this.rowSelection = new Serenity.GridRowSelectionMixin(this);
        }


        protected markupReady() {
            super.markupReady();
            if (this.autoSize != null) {
                this.autoSize.resizeAllColumns();
            }
        }
    }
}